export default "__VITE_ASSET__B7kaGCC4__"